<template>
  <v-menu
    v-if="isMounted"
    v-model="menu"
    :close-on-content-click="false"
    scroll-strategy="close"
  >
    <template #activator="{ props: p }">
      <v-btn
        v-bind="p"
        :icon="mdiLinkVariant"
        aria-label="Share"
        class="ma-1"
        color="white"
        size="small"
        variant="flat"
      />
    </template>
    <v-card min-width="280">
      <v-card-item>
        <v-text-field
          :value="shareHref()"
          density="compact"
          hide-details
          readonly
          single-line
          variant="outlined"
        ></v-text-field>
      </v-card-item>

      <v-card-actions>
        <v-btn block variant="tonal" @click="copyLink">{{
          isCopied ? 'Copied!' : 'Copy Link'
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script setup>
import { ref } from 'vue'
import { useMounted } from '@vueuse/core'
import { mdiLinkVariant } from '@mdi/js'

const props = defineProps({
  hash: {
    default: undefined,
    type: String
  },
  href: {
    default: undefined,
    type: String
  }
})

const isCopied = ref(false)
const isMounted = useMounted()
const menu = ref(false)

function shareHref() {
  const url = new URL(props.href || window.location.href)
  if (typeof props.hash === 'string') url.hash = props.hash
  return url.href
}

function copyLink() {
  if (navigator && navigator.clipboard)
    navigator.clipboard.writeText(shareHref())

  isCopied.value = true

  setTimeout(() => {
    menu.value = false
    isCopied.value = false
  }, 1000)
}
</script>
